import { motion } from 'motion/react'
import BlockTitle from 'src/components/BlockTitle'
import Portrait from 'src/components/Portrait'
import { _Picture } from 'src/components/Portrait/styled'
import Slider from 'src/components/Slider'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const Wrapper = styled(motion.div)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
`
export const _BlockTitle = styled(BlockTitle)`
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const _Slider = styled(Slider)`
  padding-inline: ${pxToRem(16)};
  overflow: hidden;
  & .keen-slider[data-keen-slider-disabled],
  & .keen-slider:not([data-keen-slider-disabled]) {
    padding-block: 1px;
    overflow: visible;
  }
  & .keen-slider__slide {
    display: flex;
    aspect-ratio: 313 / 450;

    & > :first-child {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(32)};
    & .keen-slider {
      height: calc(390 / 1440 * 100vw);
    }
    & .keen-slider[data-keen-slider-disabled] {
      display: flex;
      flex-flow: row nowrap;
      gap: ${pxToRem(16)};
      aspect-ratio: 2.75;
    }
  }
  @media ${mq(sizes.desktop)} and (hover: hover) {
    & .keen-slider__slide {
      flex: 1 1 auto;
      width: 100%;
      transition: width 0.3s ease-in-out;
    }
    & .keen-slider__slide:hover {
      width: 115%;
    }
  }
`
export const PortraitWrapper = styled(motion.div)`
  flex: 1;
`
export const _Portrait = styled(Portrait)`
  height: 100%;

  @media ${mq(sizes.desktop)} and (hover: hover) {
    width: 100%;
    height: 100%;
    & ${_Picture} {
      transform: unset !important; // the width change will suffice
    }
  }
`
